// Helpers shared by AgentRunModal and its child panels — kept side-effect free
// and dependency-light so they can be unit-tested without importing React.

export const DOW = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function timeUntil(iso) {
  if (!iso) return "—";
  const ms = new Date(iso).getTime() - Date.now();
  if (ms <= 0) return "due now";
  const m = Math.floor(ms / 60000);
  if (m < 60) return `in ${m}m`;
  const h = Math.floor(m / 60);
  if (h < 48) return `in ${h}h ${m % 60}m`;
  const d = Math.floor(h / 24);
  return `in ${d}d`;
}

export function describeSchedule(s) {
  const hh = String(s.hour_utc).padStart(2, "0");
  if (s.cadence === "daily") return `Daily · ${hh}:00 UTC`;
  if (s.cadence === "weekly") return `Weekly · ${DOW[s.day_of_week] || "Mon"} · ${hh}:00 UTC`;
  return `Monthly · day ${s.day_of_month} · ${hh}:00 UTC`;
}
